import * as React from 'react';
import {ComponentClass} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Theme, WithStyles} from "@material-ui/core";
import {bindActions, mockTheme, WithActions} from '../utils/utils';
import {IStore} from '../store';
import {connect} from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {RouteData} from '../components/routeSelector';
import  {VisitAbmState} from '../components/visits/visitAdd';

import {VisitActions} from '../store/visit/visit-actions';
import Paper from '@material-ui/core/Paper';
import {IVisitStore} from '../store/visit/visit-reducer';
import {AddVisitDTO} from '../api/model';
import { ConfigData } from '../config';
import VisitAdd from 'src/components/visits/visitAdd';
import { RouteComponentProps } from 'react-router-dom';


const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    add: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface VisitProps extends WithStyles<keyof typeof classesType>, WithActions<VisitActions>,RouteComponentProps<any> {
    visit: IVisitStore;
    config: ConfigData;
}

interface VisitsState {
    abmState: VisitAbmState
}

class Visits extends React.Component<VisitProps, VisitsState> {

    constructor(props: VisitProps) {
        super(props);

        this.state = {
            abmState: 'edit'
        };

        this.handleNewLocation = this.handleNewLocation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleNewLocation(data: RouteData) {
        console.log(data);
        this.setState({
            ...this.state,
        })
    }

    handleSubmit(data: AddVisitDTO) {
        console.log('adding new visit88');
        this.setState({
            abmState: 'adding',
        });
        this.props.actions.add(data, this.props.history);
    }

    componentWillReceiveProps(nextProps: VisitProps) {
        console.log('new props', nextProps.visit.current);
        if (nextProps.visit.current.data && nextProps.visit.current.data.type) {
            this.setState({
                abmState: 'added',
            })
        }
        if (nextProps.visit.current.error) {
            this.setState({
                abmState: 'error',
            })
        }
    }


    render() {
        console.info("visits: ", this.props)
        return (
            <Grid container spacing={24}>
                <Grid item md={12} lg={12}>
                    <Paper elevation={11} className={this.props.classes.add}>
                        <Typography variant="title" style={{ fontSize: '25px',fontStyle:'bold' }}>Agendar visita</Typography>
                        <VisitAdd handleAdd={this.handleSubmit}
                                 error={this.props.visit.current.error}
                                 state={this.state.abmState}
                                 config={this.props.config}
                                 />
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: VisitProps) => ({
    ...ownProps,
    visit: state.visit,
    config: state.config.data
});


const styled = withStyles(styles as any)(Visits);
const connected = connect(mapStateToProps, bindActions(VisitActions))(styled);

export default connected as ComponentClass<Partial<VisitProps>>;



// WEBPACK FOOTER //
// ./src/pages/visits.tsx